import { forwardRef } from "react";

const Darkener = forwardRef((props, ref) => {
    const { children, className, opacity = '0.5' } = props;

    return (
        <div ref={ref} className={`darkener ${className}`}>
            <div className="darkener__overlay" style={{ opacity: opacity }}></div>
            { children }
        </div>
    );
});

export default Darkener;